<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <vs-table :data="form.allergen_item"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th style="font-weight: normal" width="15%">Name</vs-th>
            <vs-th style="font-weight: normal" width="10%">Present in product?</vs-th>
            <vs-th style="font-weight: normal" width="10%">Manufacturing Site Present on line?</vs-th>
            <vs-th style="font-weight: normal" width="10%">Manufacturing Site Present on site?</vs-th>
            <vs-th style="font-weight: normal" width="10%">Packing Site Present on line?</vs-th>
            <vs-th style="font-weight: normal" width="10%">Packing Site Present on site?</vs-th>
            <vs-th style="font-weight: normal" width="10%">Traders Present on site?</vs-th>
            <vs-th style="font-weight: normal" width="25%">Comment</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">


              <vs-td :data="data[indextr].name">
                <vx-tooltip
                  color="primary"
                  position="left"
                  :text="allergen_item_tooltips[indextr]">
                  {{ data[indextr].name }}
                </vx-tooltip>
              </vs-td>

              <vs-td :data="data[indextr].is_present_in_product">
                <ValidationProvider :vid="indextr+'is_present_in_product'" :name="indextr+'is_present_in_product'" rules="" v-slot="{ errors }">
                  <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="data[indextr].is_present_in_product" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>


              <vs-td :data="data[indextr].is_manufacturing_line">
                <ValidationProvider :vid="indextr+'is_manufacturing_line'" :name="indextr+'is_manufacturing_line'" rules="" v-slot="{ errors }">
                  <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="data[indextr].is_manufacturing_line" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].is_manufacturing_site">
                <ValidationProvider :vid="indextr+'is_manufacturing_site'" :name="indextr+'is_manufacturing_site'" rules="" v-slot="{ errors }">
                  <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="data[indextr].is_manufacturing_site" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].is_packing_line">
                <ValidationProvider :vid="indextr+'is_packing_line'" :name="indextr+'is_packing_line'" rules="" v-slot="{ errors }">
                  <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="data[indextr].is_packing_line" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].is_packing_site">
                <ValidationProvider :vid="indextr+'is_packing_site'" :name="indextr+'is_packing_site'" rules="" v-slot="{ errors }">
                  <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="data[indextr].is_packing_site" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].is_trader_site">
                <ValidationProvider :vid="indextr+'is_trader_site'" :name="indextr+'is_trader_site'" rules="" v-slot="{ errors }">
                  <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="data[indextr].is_trader_site" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].is_comment">
                <ValidationProvider :vid="indextr+'is_comment'" :name="indextr+'is_comment'" rules="" v-slot="{ errors }">
                  <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="data[indextr].is_comment" name="is_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>


        </vs-table>

<!--        <div v-for="(allergen, index) in form.allergen_item" :key="index">-->
<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
<!--&lt;!&ndash;              <span class="text-bold " style="font-weight: bold">{{allergen.name}}</span>&ndash;&gt;-->
<!--              <small class="label">Name</small> <br>-->
<!--              <span class="text-bold " style="font-weight: normal">{{ allergen.name}}</span>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/5 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_present_in_product'" :name="index+'is_present_in_product'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Present in product?</small>-->
<!--                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="allergen.is_present_in_product" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/5 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_manufacturing_line'" :name="index+'is_manufacturing_line'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Manufacturing Site Present on line?</small>-->
<!--                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="allergen.is_manufacturing_line" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/5 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_manufacturing_site'" :name="index+'is_manufacturing_site'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Manufacturing Site Present on Site?</small>-->
<!--                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="allergen.is_manufacturing_site" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/5 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_packing_line'" :name="index+'is_packing_line'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Packing Site Present on line?</small>-->
<!--                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="allergen.is_packing_line" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/5 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_packing_site'" :name="index+'is_packing_site'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Packing Site Present on site?</small>-->
<!--                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="allergen.is_packing_site" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/5 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_trader_site'" :name="index+'is_trader_site'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Traders Present on site?</small>-->
<!--                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="allergen.is_trader_site" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-3/5 w-full md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_comment'" :name="index+'is_comment'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Comment</small>-->
<!--                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="allergen.is_comment" name="is_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--                  <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
<!--        </div>-->

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col w-full">
            <ValidationProvider vid="segregation_controls" name="segregation_controls" rules="required" v-slot="{ errors }">
              <small class="label">If any allergens are present, please provide details on segregation and controls in place to prevent cross-contamination
              </small>
              <vs-textarea :disabled="__isDisabledRawMaterial(status)" class="mb-0" v-model="form.segregation_controls" :danger="errors[0]" :danger-text="errors[0]"/>
              <span class="text-danger mt-0 text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_allergen_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

    export default {
        name: "SupplierManufacturingHome",
      data() {
          return {
            form: {
              allergen_item: [
                {
                  name: "cereals",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "crustaceans",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "eggs",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "fish",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "peanuts",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "soybeans",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "milk",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "nuts",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "celery",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "mustard",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "sesame",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "sulphur",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "molluscs",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                },
                {
                  name: "lupins",
                  is_present_in_product: false,
                  is_manufacturing_line: false,
                  is_manufacturing_site: false,
                  is_packing_line: false,
                  is_packing_site: false,
                  is_trader_site: false,
                  is_comment: ""
                }
              ]
            },
            id: null,
            status: {},
            allergen_item_tooltips: [
              'Cereals containing gluten and products thereof (Wheat, Rye, Barley, Oats, Spelt, Kamut) or their derivatives',
              'Crustaceans and products thereof',
              'Eggs and products thereof',
              'Fish and products thereof',
              'Peanuts and products thereof',
              'Soybeans and products thereof',
              'Milk and dairy products (including lactose)',
              'Nuts and nut products Almond, Hazelnut, Walnut, Cashew, Pecan nut, Brazil nut, Pistachio nut, Macadamia nut and Queensland nut, Pine nut, Chestnut',
              'Celery and products thereof',
              'Mustard and products thereof',
              'Sesame seeds and products thereof',
              'Sulphur dioxide and sulphites (>10mg/kg )',
              'Molluscs and products thereof',
              'Lupins and products thereof'
            ]
          }
      },
      mixins: [SuccessMessage, ErrorMessages],
      methods: {
        onClickNext() {
          this.$emit('notify', 1)
        },
        onClickSubmit() {
          this.status.is_raw_material_allergen_complete ? this.onClickUpdate() : this.onClickCreate()
        },

        async onClickUpdate() {
          this.$vs.loading()
          try {
            const data= (await SupplierRawMaterialRepository.UpdateRawMaterialAllergens(this.id, this.form))
            this.showSuccessMessage('Raw Material Allergens Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async onClickCreate() {
          this.$vs.loading()
          try {
            const data= (await SupplierRawMaterialRepository.CreateRawMaterialAllergens(this.form))
            this.showSuccessMessage('Raw Material Allergens Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

        async loadData() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialAllergens(this.id)).data
          this.form =data
          this.$vs.loading.close()
        },
        async loadStatus() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
          this.status =data
          this.$vs.loading.close()
        }
      },
      async mounted() {
        this.id = this.$route.params.id
        this.form.supplier_raw_material_id =  this.id
        await this.loadStatus()
        if (this.status.is_raw_material_allergen_complete) {
          await this.loadData()
        }
      }
    }
</script>

<style scoped>

</style>
